import { site } from '@yola/ws-sdk';
import saveSite from 'src/js/modules/saving/helpers/save-site';
import store from '../../../store';

const setAndSaveActivePageAfterLocaleChange = async ({ destinationLocale, originLocale }) => {
  const state = store.getState();
  const newActivePage =
    site.selectors.getHomePage(state, destinationLocale) ||
    site.selectors.getHomePage(state, originLocale);

  await site.operations.setActivePage(newActivePage.id);
  saveSite();
};

export default setAndSaveActivePageAfterLocaleChange;
